import {createApp} from 'vue';
import eventBus from '@/core/plugins/bus';
import i18n from '@/core/plugins/i18n';
import store from '@/core/plugins/store';
import queryBus from '@/core/plugins/queryBus';
import themes from '@/core/constants/themes';

import AppReports from './AppReports.vue';

import '@/assets/styles/main.sass';
import 'redmine-ui-kit/dist/style.css';

loadChartThemes().then(init);

function init(loadedThemes) {
    const userData = JSON.parse(window?.current_user ?? '{}');

    const app = createApp(AppReports);
    app.use(eventBus);
    app.use(i18n);
    app.use(store, {userData, isRequestPending: false, chartData: window.chartData, loadedThemes});
    app.use(queryBus);

    app.mount('#kanban-reports');
}

async function loadChartThemes() {
    const loadedThemes = {};

    for (const theme of themes) {
        try {
            loadedThemes[theme] = {...await import(`@/assets/themes/${theme}.json`)};
        } catch(error) {
            console.error(error);
        }
    }

    return loadedThemes;
}
